import { useEffect } from 'react';
import { useStores } from 'stores/useStores';

import { TestState } from '../types/test-state.enum';

export const useGetBreeds = () => {
  const { breedStore, testsStore, sessionStore } = useStores();
  const { petProfile, isProfileLoaded } = testsStore;

  useEffect(() => {
    if (!isProfileLoaded
      || petProfile?.testState === TestState.RECOLLECT
      || !sessionStore.sessionValid
    ) {
      return;
    }

    if (petProfile) {
      breedStore.getBreedResults(petProfile.testGUID);
    }
  }, [isProfileLoaded, petProfile, sessionStore.sessionValid]);

  return { breedStore };
};
